module.exports = __webpack_public_path__ + "img/top-bar.fce57639.png";